import React, { useState } from "react";
import Footer from "./LandingPage/Footer";
import Header from "./LandingPage/Header";
import LanguageSelector from "./Languages/LanguageSelector";

const PartnerSupport = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const supportData = {
    email: "partnersupport@fetandelivery.com",

    faqs: [
      {
        category: "Partner Account / Onboarding / Login",
        items: [
          "Complete your partner onboarding and document verification to start deliveries.",
          "If you are unable to log in, use the 'Forgot Password' option.",
          "Contact partner support if your account is under review or suspended.",
        ],
      },
      {
        category: "Orders & Delivery Process",
        items: [
          "Accept delivery requests from the Partner App dashboard.",
          "Ensure timely pickup and delivery to maintain your rating.",
          "If an order is canceled or reassigned, check the order details section.",
        ],
      },
      {
        category: "Earnings, Payouts & Incentives",
        items: [
          "Earnings are calculated based on completed deliveries.",
          "Weekly payouts are credited to your registered bank account.",
          "Contact support if your payout is delayed or incorrect.",
        ],
      },
      {
        category: "App Issues & Safety Support",
        items: [
          "Update the app regularly to avoid performance issues.",
          "Report technical issues directly through the app support section.",
          "For emergencies during delivery, contact partner support immediately.",
        ],
      },
    ],

    policies: [
      { name: "Partner Terms & Conditions", link: "/partner-terms" },
      { name: "Payment & Incentive Policy", link: "/partner-payment-policy" },
      { name: "Safety & Conduct Guidelines", link: "/partner-safety-policy" },
    ],
  };

  return (
    <div>
      <div
        className="navbar-expand-lg navbar-light  fixed-top"
        style={{ zIndex: "99999" }}
      >
        <LanguageSelector />
      </div>
      <Header />
      <div className="container py-4" style={{ marginTop: "100px" }}>
        {/* Header */}
        <div className="mb-4">
          <h1 className="fw-bold text-light">Partner Support</h1>
          <p className="text-muted">
            Get help with deliveries, earnings, app issues, and partner
            policies.
          </p>
        </div>

        {/* Contact */}
        <div className="mb-5">
          <h3>
            <i className="bi bi-envelope-fill text-light me-2"></i>
            Contact Support
          </h3>
          <p className="fw-bold text-primary">{supportData.email}</p>
        </div>

        {/* FAQs */}
        <div className="mb-5">
          <h3>
            <i className="bi bi-question-circle-fill text-light me-2"></i>
            Frequently Asked Questions
          </h3>

          <div className="accordion">
            {supportData.faqs.map((faq, index) => (
              <div className="accordion-item" key={index}>
                <button
                  className="accordion-button bg-info"
                  onClick={() => toggleFaq(index)}
                  style={{ boxShadow: "none" }}
                >
                  {faq.category}
                </button>

                {activeIndex === index && (
                  <div className="accordion-body bg-light text-info">
                    <ul>
                      {faq.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Policies */}
        <div>
          <h3>
            <i className="bi bi-file-text text-light me-2"></i>
            Policies
          </h3>
          <ul className="d-flex gap-5">
            {supportData.policies.map((policy, index) => (
              <li key={index}>
                <a href={policy.link} className="text-primary">
                  {policy.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PartnerSupport;
